module.exports = "idFields: {\n  customerId: {{transactionCustomerId}}\n}\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionCustomerID.html
// module id = 2156
// module chunks = 0